module.exports = __webpack_public_path__ + "static/media/1020668.9f610f7a.png";